import { BetslipBetBuilderPick } from '../../../../core/picks/betslip-bet-builder-pick';
import { BaseBetslipGroupPick } from '../../../../core/picks/betslip-group-pick';
import { BetslipPick } from '../../../../core/picks/betslip-pick';
import { PickOddsState } from '../../../../core/picks/pick-models';
import { underMinimumBetBuilderSelections } from '../validators/betslip/min-selections-betbuilder.validator';
import { underMinimumGroupPickLegs } from '../validators/type/combo-bet/group-pick-combo-bet-min-selection.validator';

export function isIncompleteBetBuilderPick(pick: BetslipPick): boolean {
    const isIncompleteBab = BetslipBetBuilderPick.isEntainUiBetBuilderPick(pick) && underMinimumBetBuilderSelections(pick);
    const isIncompleteGroupPick = BaseBetslipGroupPick.isPick(pick) && underMinimumGroupPickLegs(pick);

    return isIncompleteBab || isIncompleteGroupPick;
}

export function isGroupPickWithRestrictedLiveLegs(enabledCompetitions: number[] | undefined, pick: BetslipPick): boolean | undefined {
    const isRestricted =
        BaseBetslipGroupPick.isPick(pick) &&
        pick.oddsState === PickOddsState.Open &&
        pick.isLive &&
        !enabledCompetitions?.includes(pick.competitionId);

    return isRestricted;
}
